import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Select, Radio, DatePicker } from 'antd';
import Draggable from 'react-draggable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectCenter from "../util/SelectCenter";
import SearchClientPopup from "./SearchClientPopup";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import ko from 'date-fns/locale/ko';
import { useSelector } from 'react-redux';
import moment from 'moment';
import setup from '../setup';
registerLocale('ko', ko)

const { Option } = Select;
const { RangePicker } = DatePicker;

const layout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 9,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

const enrollConfig = {
    rules: [
      {
        type: 'array',
        required: true,
        message: '수강신청기간을 입력해 주세요!',
      },
    ],
};

const classConfig = {
    rules: [
      {
        type: 'array',
        required: true,
        message: '수강기간을 입력해 주세요!',
      },
    ],
};

function FrequencyPopup(props) {
    const [cid, setCid] = useState('');
    const [showSearch, setShowSearch] = useState(false);
    const [mcd, setMcd] = useState('');
    const [name, setName] = useState('');
    const [selectedCenter, setSelectedCenter] = useState('');
    const [title, setTitle] = useState('');
    const [totalFrequency, setTotalFrequency] = useState(0);
    const data = useSelector(state => state.data);
    const [form] = Form.useForm();

    function toggleSearch() {
        setShowSearch(!showSearch)
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
        form.setFieldsValue({
            cid: cid
        });
    }

    function onInfoSubmit(name, cd) {
        setName(name);
        form.setFieldsValue({
            name: name,
            cd : cd
        });
    }

    const onFinish = (values) => {
        const { cid, cd, class_date } = values;
        let format_class_date = moment(class_date).format('YYYY-MM-DD');
        
        (async function () {
            const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
            const result = await axios.post(api_host + '/fq/add_stamp', {
                mcd : cd,
                cid: cid,
                class_date : format_class_date,
                res_seq : 0
            })
            if(result.data.ret == 'Y'){
                alert('등록되었습니다');
                props.closePopup("updated");
            }else{
                alert(result.data.msg)
            }
        })();
    };

    async function deleteCoupon(seq) {
        const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
        const result = await axios.post(api_host + '/hg_admin/delete_frequency', {
            seq : seq
        })
        if(result.data.ret == 'Y'){
            alert('삭제되었습니다');
            props.closePopup("updated");
        }else{
            alert(result.data.msg)
        }
    }

    function handleDelete() {
        confirmAlert({
            title: '삭제 확인',
            message: props.data.name + "님의 프리퀀시를 삭제하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => deleteCoupon(props.data.seq)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    useEffect(()=>{
        console.log(props.data);
        if(props.mode === "add"){
            setTitle("프리퀀시 추가");
        }else if(props.mode === "edit"){
            setTitle("프리퀀시 상세정보");
            setName(props.data.name);
            setCid(props.data.cid);
            setMcd(props.data.mcd);
            (async function () {
                const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
                const result = await axios.post(api_host + '/fq/get_stamp_point', {
                    mcd : props.data.mcd,
                    cid: props.data.cid
                })
                setTotalFrequency(result.data.active_point)
            })();
        }else{
            alert("정상적인 접근이 아닙니다.")
        }
    },[]);

    return(
        <div className="popup frequency">
            <Draggable handle=".handle">
            <div className="popupInner">
            <div className="handle">
            <h3>{title}</h3>
            <FontAwesomeIcon icon={faTimes} onClick={() => props.closePopup("")} className="closeIcon" />
            </div>
            <Form {...layout} form={form} onFinish={onFinish}>
            <Form.Item
                name="name"
                label="고객명"
                rules={[{ required: true, message: '고객명을 입력해 주세요.' }]}
            >
                {props.mode === 'add' ?
                <Input.Group>
                <Input.Search type="text" readOnly onSearch={toggleSearch} value={name}/>
                </Input.Group>
                :
                <>
                {name + " / 총 프리퀀시 {" + totalFrequency+"}"}
                </>
                }
            </Form.Item>
            <Form.Item
                name="cid"
                label="센터명"
                rules={[{ required: true, message: '센터를 선택해 주세요.' }]}
            >
                {props.mode === 'add' ?
                <SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100"/>
                :
                <SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100" readOnly/>
                }
            </Form.Item>
            <Form.Item name="class_date" label="수업일자" rules={[{ required: true, message: '수업일자를 선택해 주세요.' }]}>
                {props.mode === 'add' ?
                <DatePicker format="YYYY-MM-DD" />
                :
                <>
                {moment(props.data.class_date).format('YYYY-MM-DD')}
                </>
                }
            </Form.Item>
            {props.mode === 'add' ? <></>
            :
            <Form.Item name="exp_date" label="만료일자">
                {moment(props.data.exp_date).format('YYYY-MM-DD')}
            </Form.Item>
            }
            {props.mode === 'add' ? <></>
            :
            <Form.Item name="state" label="상태" rules={[{ required: true, message: '상태를 선택해 주세요.' }]}>
                {props.data.state === 1 ? "Y" : "N"}
            </Form.Item>
            }
            <Form.Item name="cd" noStyle>
                <Input type="hidden" />
            </Form.Item>
            <Form.Item {...tailLayout}>
                {props.mode === "add" ? 
                    <Button type="primary" htmlType="submit">추가</Button>
                    :
                    <>
                    <Button type="danger" onClick={handleDelete}>삭제</Button>
                    </>
                }
            </Form.Item>
            </Form>
            {showSearch ? 
            <SearchClientPopup
                closePopup={toggleSearch}
                onSubmit = {onInfoSubmit}
                onlyClient
            />
            : null
            }
            </div>
            </Draggable>
        </div>
    )
}

export default FrequencyPopup;
